import { Pipe, PipeTransform } from '@angular/core';
import { getInitials } from 'utilities';

@Pipe({
  name: 'initials',
})
export class InitialsPipe implements PipeTransform {
  transform(
    user:
      | { displayName?: string; firstName?: string; lastName?: string; email?: string }
      | undefined
      | string
  ): string {
    if (!user) return '?';

    if (typeof user === 'string') {
      return getInitials(user);
    }

    const displayName = user.displayName || `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim();
    if (displayName) {
      const parts = displayName.split(/\s+/);
      if (parts.length >= 2) {
        return (parts[0][0] + parts[1][0]).toUpperCase();
      }
      return displayName.substring(0, 2).toUpperCase();
    }

    if (user.email) {
      return user.email.substring(0, 2).toUpperCase();
    }

    return '?';
  }
}
